import DgContextmenu from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgContextmenu.install = function (Vue) {
  Vue.component(DgContextmenu.name, DgContextmenu)
}
export default DgContextmenu

export { DgContextmenu }